import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Normalizes trailing-slash URLs (e.g. /about/) to their canonical
 * non-trailing-slash form (/about). The homepage "/" is left untouched.
 * Static SPA hosting cannot emit a server-side 301, so this performs the
 * equivalent client-side normalization as early as possible.
 */
const TrailingSlashRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== "/" && pathname.endsWith("/")) {
      navigate(`${pathname.replace(/\/+$/, "")}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
};

export default TrailingSlashRedirect;
